/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentWorkflowInstanceStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    ERROR = 'ERROR',
    EXPIRED = 'EXPIRED',
    PENDING_ADDITIONAL_SIGNATURES = 'PENDING_ADDITIONAL_SIGNATURES',
    PENDING_FORM_SUBMISSION = 'PENDING_FORM_SUBMISSION',
    REJECTED = 'REJECTED',
}
